import React, { forwardRef } from 'react';
import { Container, Row } from 'react-bootstrap'; // Adjust based on your usage

const PrintableContent = forwardRef((props, ref) => (
  <div ref={ref} id="page-content-wrapper">
    <Container fluid>
      <Row className="startingrow">
        {props.children}
      </Row>
    </Container>
  </div>
));

export default PrintableContent;
